// ---------- AUTH
export const GET_CHANNEL_KEY = 'GET_CHANNEL_KEY';
export const GET_API_KEY = 'GET_API_KEY';
export const GET_PROFILE = 'GET_PROFILE';
export const DO_LOGIN = 'DO_LOGIN';
export const DO_REGISTRATION = 'DO_REGISTRATION';
export const DO_LOGOUT = 'DO_LOGOUT';
export const DO_VERIFY = 'DO_VERIFY';
export const DO_PASSWORD_RESET_REQUEST = 'DO_PASSWORD_RESET_REQUEST';
export const DO_PASSWORD_RESET = 'DO_PASSWORD_RESET';
export const DO_UPDATE_PROFILE = 'DO_UPDATE_PROFILE';

// ---------- CHANNEL

export const GET_CHANNEL_SETTINGS = 'GET_CHANNEL_SETTINGS';
export const GET_CHANNEL_MENU = 'GET_CHANNEL_MENU';
export const GET_CHANNEL_SLIDES = 'GET_CHANNEL_SLIDES';
export const GET_CHANNEL_PAGES = 'GET_CHANNEL_PAGES';
export const GET_CHANNEL_PAGE = 'GET_CHANNEL_PAGE';

// ---------- CUSTOM FORM
export const GET_CUSTOM_FORM_DATA = 'GET_CUSTOM_FORM_DATA';

// ---------- EVENT
export const GET_EVENTS_LIST = 'GET_EVENTS_LIST';
export const GET_EVENT = 'GET_EVENT';
export const DOWNLOAD_EVENT = 'DOWNLOAD_EVENT';
export const GET_EVENT_CATEGORIES = 'GET_EVENT_CATEGORIES';

// ---------- FAQ
export const GET_FAQ = 'GET_FAQ';

// ---------- GEO
export const GET_GEO_DATA = 'GET_GEO_DATA';

// ---------- PARTICIPANT
export const GET_PARTICIPANTS_LIST = 'GET_PARTICIPANTS_LIST';

// ---------- PAYMENT
export const PAYMENT_PREPARE = 'PAYMENT_PREPARE';
export const PAYMENT_PAY = 'PAYMENT_PAY';
export const GET_PACKAGES_CACHED = 'GET_PACKAGES_CACHED';
export const GET_PACKAGES = 'GET_PACKAGES';
export const GET_SUBSCRIPTIONS_CACHED = 'GET_SUBSCRIPTIONS_CACHED';
export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';
export const GET_EVENT_PACKAGES = 'GET_EVENT_PACKAGES';
export const GET_PACKAGE = 'GET_PACKAGE';
export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION';
export const GET_ORDERS = 'GET_ORDERS';
export const GET_ORDER_BY_ID = 'GET_ORDER_BY_ID';
export const APPLY_COUPON = 'APPLY_COUPON';

// ----------- VOD MEDIA
export const GET_VOD_ITEMS = 'GET_VOD_ITEMS';
export const GET_VOD_ITEM = 'GET_VOD_ITEM';
export const GET_VOD_CATEGORIES = 'GET_VOD_CATEGORIES';
export const SEARCH_IN_VOD = 'SEARCH_IN_VOD';
